<div clas="notification-date-filed">
   <div *ngIf="item?.cells[fieldDefinitionKeyModel]?.value?.IsNotApplicable" 
       matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
       {{this.item?.cells[this.fieldDefinition.key]?.displayText ? this.item?.cells[this.fieldDefinition.key]?.displayText : ''}}
   </div>

   <div *ngIf="!item?.cells[fieldDefinitionKeyModel]?.value?.IsNotApplicable" class="notification-date-filed-applicable">
       <div class="status-color" [ngClass]="item?.cells[fieldDefinitionKeyModel]?.value?.CalculatedStatusColorClass"></div>
       <div class="display-text" (click)="emitSidebarData()"
            matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
            {{item?.cells[this.fieldDefinition.key]?.displayText}}
        </div>
   </div>
</div>